import React, { useContext, useEffect, useState } from "react";

import Image from "next/image";
import { GlobalContext } from "context";
import {
  SET_USER_MENUS,
  SET_LANGUAGES,
  SET_CATEGORIES,
} from "context/actions/system";
// component
import Header from "components/Header";
import Footer from "components/Footer";
import DevelopeDialog from "components/DevelopDialog";
import LoadingDialog from "components/global/LoadingDialog";
import CustomSnackBar from "components/CustomSnackBar";
import { SHOW_DEVELOP, SET_ALERT } from "context/actions/system";
import { getPageList } from "context/actions/pages";
import { getCategoriesList } from "context/actions/categories";
import Alert from "@mui/material/Alert";
import i18n from "i18next";
import useWindowSize from "utils/useWindowSize";
import { Facebook, Instagram } from "react-feather";
import { Box, Typography, Container, Button } from "@mui/material";

export default function HomeLayout({ children }) {
  const { sizes } = useWindowSize();
  const { state, dispatch } = useContext(GlobalContext);
  const [isGetAllData, setGetAllData] = useState(false);
  const [showBarcode, setShowBarcode] = useState(false);

  useEffect(() => {
    getDatas();
  }, []);

  const getDatas = async () => {
    const datas = await getPageList(true, "", dispatch);
    if (datas.status === "success") {
      dispatch({
        type: SET_USER_MENUS,
        data: datas.data,
      });
    }
    const categoriesRes = await getCategoriesList(null, "&fromMenu=1");
    if (categoriesRes.status === "success") {
      dispatch({
        type: SET_CATEGORIES,
        data: categoriesRes.data,
      });
    }
    setGetAllData(true);
  };

  const handleClick = () => {
    setShowBarcode(!showBarcode);
  };

  return (
    <>
      <div>
        <main>
          {isGetAllData ? (
            <>
              <Header />
              <div>{children}</div>
              <Footer />
            </>
          ) : (
            <div className="flex flex-col flex-1 justify-center items-center h-screen">
              <Image
                width={sizes.sm ? 180 : 200}
                height={sizes.sm ? 48 : 60}
                src={i18n.language === "mn" ? "/Logos.png" : "/Logos.png"}
                alt=""
                style={{ objectFit: "cover" }}
              />
              <Image
                width={180}
                height={48}
                src={"/global/loading.gif"}
                alt=""
                style={{ objectFit: "cover" }}
              />
            </div>
          )}
          {state.system.showDevelop && (
            <DevelopeDialog
              open={state.system.showDevelop}
              handleClose={() => {
                dispatch({ type: SHOW_DEVELOP, data: false });
              }}
            />
          )}

          {state.system.showLoading && (
            <LoadingDialog open={state.system.showLoading} />
          )}
          {state.system.alert.isShow && (
            // <Alert severity={state.system.alert.type} variant="outlined" className="">
            //     asf
            // </Alert>

            <CustomSnackBar
              open={state.system.alert.isShow}
              msg={state.system.alert.message}
              handleClose={() => {
                dispatch({
                  type: SET_ALERT,
                  data: { isShow: false, type: "", message: "" },
                });
              }}
              type={state.system.alert.type}
            />
          )}
        </main>
        <Box className="fixed bottom-[50px] right-[30px] flex flex-col z-[9893]">
          <a
            href="https://ezentravel.mn/brochure"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Box
              style={{ fontFamily: "Philosopher", color: "#4f4235" }}
              className="bg-[#fff] text-[18px] font-bold  h-[50px] w-[200px] flex justify-center items-center rounded-lg"
            >
              + Аялалд бүртгүүлэх
            </Box>
          </a>
        </Box>
        {/* <Box className="fixed bottom-[350px] right-[30px] flex flex-col z-[9893]">
          <a
            href="https://www.facebook.com/profile.php?id=61579910966244"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Box className="bg-[#0966ff] h-[50px] w-[50px] flex justify-center items-center rounded-[50px]">
              <Facebook color="#fff" size={30} />
            </Box>
          </a>
        </Box>
        <Box className="fixed bottom-[280px] right-[30px] flex flex-col z-[9893]">
          <Box className="bg-[#0966ff] h-[50px] w-[50px] flex justify-center items-center rounded-[50px] cursor-pointer">
            <a
              href="https://www.instagram.com/ezen.travel/?fbclid=IwY2xjawMeTrxleHRuA2FlbQIxMABicmlkETFDQnJMM3BjVDNhOWNlNVZEAR7I1eNozW1aRIejDm6AqCm3BLqdbh7uoWyjlyd424r3xu4JYkMFh7ErL_CqBw_aem_ybliG3rEmxIdwnLlezaYxw"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                width={50}
                height={50}
                src="/insta.jpg" // Path to Instagram image
                alt="insta"
                className="object-contain rounded-[50px]"
              />
            </a>
          </Box>
        </Box>

       
        <Box className="fixed bottom-[210px] right-[30px] flex flex-col z-[9893]">
          <a
            href="https://www.tiktok.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              width={50}
              height={50}
              src="/tik.png" // Path to TikTok image
              alt="tik"
              className="object-contain rounded-[50px]"
            />
          </a>
        </Box> */}
      </div>
    </>
  );
}
